import React from "react";
import DocumentPreviewModal from "../../common/DocumentPreview/DocumentPreviewModal";

/**
 * QMS/legacy modal wrapper — uses shared DocumentPreviewModal (PDF/image, no OnlyOffice).
 */
function QmsDocumentPreviewModal({
  open,
  onClose,
  documentUrl,
  documentExtension,
  documentTitle,
  documentCode,
  documentId = "",
  sourceModule = "QMS",
  sourceTable = "DMS_MyVault_Documents",
}) {
  return (
    <DocumentPreviewModal
      open={open}
      onClose={onClose}
      sourceModule={sourceModule}
      sourceTable={sourceTable}
      documentId={documentId}
      documentUrl={documentUrl}
      documentExtension={documentExtension}
      documentTitle={documentTitle}
      documentCode={documentCode}
    />
  );
}

export default QmsDocumentPreviewModal;
